import React, { Suspense } from 'react'
import BoxUi from '../../ui/BoxUi/BoxUi'
import styles from './cabinets.module.scss'
import { Outlet, useParams } from 'react-router-dom'
import useCurrentTabWithParams from '../../../hooks/useCurrentTabWithParams'
import useCurrentTabObject from '../../../hooks/useCurrentTabObject'
import { cabinetsTabs, cabinetsTabsTitle } from './cabinets.tabs'
import PageSpinner from '../../ui/PageSpinner/PageSpinner'
import { TabsUi } from '../../ui/TabsUi/TabsUi'
import { CabinetInfoProvider } from './cabinet-info.provider'

export const CabinetLayout: React.FC = () => {
  const { cabinetId } = useParams<{ cabinetId: string }>();
  const activeTab = useCurrentTabWithParams(cabinetsTabs(cabinetId ?? ''))
  const activeObj = useCurrentTabObject(cabinetsTabsTitle, activeTab)

  return (
    <CabinetInfoProvider>
      <BoxUi className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>{activeObj?.title ?? ''}</div>
        </div>
        <TabsUi
          className={styles.antTabsCabinets}
          defaultActiveKey='0'
          activeKey={String(activeTab)}
          items={cabinetsTabs(cabinetId ?? '').map((el, index) => ({
            label: el.title,
            key: String(index),
          }))}
        />
      </BoxUi>
      <Suspense fallback={<PageSpinner className={styles.loadSpin} />}>
        <Outlet />
      </Suspense>
    </CabinetInfoProvider>
  )
}
